import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import GenericMessage from 'src/components/generic-message';
import { getFilterCommentsByUser } from 'src/redux/pull-request/selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';

import messages from './diff.i18n';

export function NoFilesMatchFiltersMessage() {
  const currentUser = useSelector(getCurrentUser);
  const filterUuid = useSelector(getFilterCommentsByUser);
  const isCurrentUser = currentUser && currentUser.uuid === filterUuid;

  return (
    <GenericMessage
      iconType="info"
      title={
        <FormattedMessage
          {...messages.noFilesMatchFilter}
          values={{ isCurrentUser }}
        />
      }
    />
  );
}
